import React from 'react'
import { shallowEqual, useSelector } from 'react-redux'
import { selectors } from '@hixme/auth-ui'
import styled from 'styled-components'

import { useEnvironmentBar } from 'components/Header/environmentIndicator'

const HeaderContainer = styled.section`
  margin-top: 10px;
  color: white;
  p {
    opacity: 0.7;
    margin-bottom: 2px;
  }
  h4 {
    margin-top: 0;
  }
`

function hideZendeskWidget() {
  try {
    window.zE?.('messenger', 'hide')
  } catch (e) {
    // idgaf (it is just for demo purposes to hide the widget)
  }
}

const NavigationHeader = () => {
  const { toggleEnvironmentBarColor } = useEnvironmentBar()
  const userName = useSelector((state) => {
    const { firstname, lastname } = selectors.getCredentials(state)
    return `${firstname} ${lastname}`
  }, shallowEqual)
  return (
    <HeaderContainer>
      <p>Signed in</p>
      <h4
        onClick={() => {
          hideZendeskWidget()
          toggleEnvironmentBarColor()
        }}
      >
        {userName}
      </h4>
    </HeaderContainer>
  )
}

export default NavigationHeader
